// import {useEffect} from 'react'
// import {Navigate, Routes} from 'react-router-dom'
// import {useAuth} from './core/Auth'

// export function Logout() {
//   const {logout} = useAuth()
  
//   useEffect(() => {
//     logout()
//     document.location.reload()
//   }, [logout])

//   return (
//     <Routes>
//       <Navigate to='/auth/login' />
//     </Routes>
//   )
// }
//src/app/modules/auth/Logout.tsx
import { useState, useEffect } from 'react';
import { Navigate, Routes } from 'react-router-dom';
import { useAuth } from './core/Auth';
import { Modal, Button } from 'react-bootstrap';

export function Logout() {
  const { logout } = useAuth();
  const [showModal, setShowModal] = useState(true);
  const [confirmed, setConfirmed] = useState(false);

  const handleConfirm = () => {
    logout();
    document.location.reload();
    setConfirmed(true);
  };

  return (
    <>
      {!confirmed && (
        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Logout</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to logout?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleConfirm}>
              Logout
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {confirmed && (
        <Routes>
          <Navigate to="/auth/login" />
        </Routes>
      )}
    </>
  );
}
